<div role="dialog" aria-modal="true" class="fade modal show" tabindex="-1" style="display: block;" *ngIf="showModal">
  <div (click)="$event.stopPropagation()" class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h4>
        <strong>  Aviso Importante
</strong>
        </h4>
        <button class="btn-close" type="button" class="close" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <h5> <strong> Resolución SIS Núm. 05-2025</strong></h5>
        <p>La Superintendencia de Seguros informa que a partir del 1 de julio de 2025 entran en vigor los nuevos límites
          mínimos obligatorios de cobertura en materia de Responsabilidad Civil para el seguro de vehículos de motor.
          (Resolución Núm. 05-2025, de fecha 23/05/2025).</p>
        <a href="/assets/img/circular-aviso.jpeg" target="_blank" rel="noopener noreferrer"
          style="display: block; text-align: center;">
          <img src="/assets/img/circular-aviso.jpeg" alt="aviso circular" style="cursor: pointer; max-height: 500px;"
            class="img-fluid mb-3">
        </a>
      </div>

      <div class="modal-footer">
        <div class="d-flex justify-content-between w-100">
          <div class="mr-auto">
            <div class="form-check">
              <label class="form-check-label">
                <input type="checkbox" class="form-check-input" [(ngModel)]="dontShowAgain"
                (ngModelChange)="saveToLocalStorage()">
                No volver a mostrar este mensaje
              </label>
            </div>
          </div>
          <div>
            <button type="button" class="btn btn-secondary" (click)="closeModal()">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
